import React, { ReactElement } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useAuthStore } from "../store/useAuthStore";

import DashboardLayout from "../components/layout/Dashboard/DashboardLayout";
import BulkUpload from "../features/bulk-upload/BullkUpload";
import Search from "../features/search/Search";
import Dashboard from "../features/dashboard/Dashboard";
import APIAccess from "../features/api-access/APIAccess";
import APIAnalytics from "../features/api-access/APIAnalytics";
import UserProfile from "../features/user-profile/UserProfile";
import SearchHistory from "../features/lists/SearchHistory";
import SearchHistoryDetail from "../features/lists/SearchHistoryDetail";
import Billing from "../features/billing/Billing";
import SupportTickets from "../features/support/SupportTickets";
import LandingPage from "../features/landing/LandingPage";
import Login from "../features/auth/Login";
import Register from "../features/auth/Register";
import VerifyEmailCallback from "../features/auth/VerifyEmailCallback";
import TermsOfService from "../features/legal/TermsOfService";
import PrivacyPolicy from "../features/legal/PrivacyPolicy";
import RefundPolicy from "../features/legal/RefundPolicy";
import ContactPage from "../features/legal/ContactPage";

const ProtectedRoute = ({ children }: { children: ReactElement }) => {
  const { isAuthenticated } = useAuthStore();
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return children;
};

function AppRoutes(): ReactElement {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/email-verified" element={<VerifyEmailCallback />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/refund" element={<RefundPolicy />} />
        <Route path="/contact" element={<ContactPage />} />

        {/*  Dashboard Routes */}
        
        <Route path="/dashboard" element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
          <Route index element={<Dashboard />} />
          <Route path="search" element={<Search />} />
          <Route path="bulk-upload" element={<BulkUpload />} />
          <Route path="search_history" element={<SearchHistory />} />
          <Route path="search_history/:taskId" element={<SearchHistoryDetail />} />
          <Route path="billing" element={<Billing />} />
          <Route path="support" element={<SupportTickets />} />
          <Route path="api-access" element={<APIAccess />} />
          <Route path="api-analytics" element={<APIAnalytics />} />
          <Route path="my-profile" element={<UserProfile />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default AppRoutes;